export default {
    approvals: {
        title: "Approval",
        error: "An error occurred"
    },
    delegates: {
        title: "Delegates",
        error: "An error occurred",
        noDelegates: "No items",
        delegateDelete: "Delegate has been deleted",
        confirm: {
            delete: "Delete delegate?"
        },
        delegates: {
            email: "Email",
            startDate: "Start Date",
            endDate: "End Date",
        },
        buttons: {
            add: {
                text: "Add Delegate"
            }
        }
    },
    employees: {
        title: "My Employees",
        error: "An error occurred",
        empty: "No employees found",
        users: {
            name: "Name",
            email: "Email"
        },
        model: {
            search: {
                placeholder: "Search",
            }
        },
        cta: {
            orders: "Load orders",
            download: "Download orders",
            search: "Search"
        }
    }
}